
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllOrdersAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payoutFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllOrdersAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currentPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"keyword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestType"}}},{"kind":"Argument","name":{"kind":"Name","value":"payoutFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payoutFilter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"results"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userPayableFare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userServiceFare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shopServiceFare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driverServiceFare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSpecialDelivery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specialDeliveryFare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPayoutPaidForDelivery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPayoutPaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driverTotalFare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shopTotalFare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"shopDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPartnerDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":856}};
    doc.loc.source = {"body":"query getAllOrdersAdmin($currentPage: Int, $keyword: String, $requestType: String, $payoutFilter: String) {\n  getAllOrdersAdmin (currentPage: $currentPage, keyword: $keyword, requestType: $requestType, payoutFilter: $payoutFilter) {\n    status\n    errorMessage\n    count\n    results {\n        id\n        orderId\n      \tbookingStatus\n        paymentType\n      \tcurrency\n        userPayableFare\n      \tuserServiceFare\n      \tshopServiceFare\n      \tdriverServiceFare\n        isSpecialDelivery\n      \tspecialDeliveryFare\n        isPayoutPaidForDelivery\n        isPayoutPaid\n        driverTotalFare\n        shopTotalFare\n      \tuserDetails {\n          firstName\n          phoneNumber\n        }\n      \tshopDetails {\n          shopName\n          phoneNumber\n        }\n      \tdeliveryPartnerDetails {\n          firstName\n          phoneNumber\n        }\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getAllOrdersAdmin"] = oneQuery(doc, "getAllOrdersAdmin");
        
